<template>
  <v-container grid-list-xl>
    <v-layout column>
      <v-flex v-if="Business">
        <div v-if="$vuetify.breakpoint.xsOnly">
          <div class="text-center mt-4">
            <img v-if="Business.imageUrl" height="50" :src="Business.imageUrl" alt="Logo" />
            <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
            <div v-if="Business.phoneNumber">
              {{ Business.phoneNumber | USPhoneNumber }}
            </div>
            <div>
              <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
                }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
              <span v-if="Business.zip">{{ Business.zip }}</span>
            </div>
          </div>
        </div>

        <div v-else>
          <v-layout class="mt-4 mx-2 mr-4" align-content-space-between row wrap>
            <v-flex>
              <img v-if="Business.imageUrl" height="100" :src="Business.imageUrl" alt="Logo" />
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex>
              <div class="text-right">
                <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
                <div>
                  <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{
                    Business.city
                    }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
                  <span v-if="Business.zip">{{ Business.zip }}</span>
                </div>
                <div v-if="Business.phoneNumber">
                  {{ Business.phoneNumber | USPhoneNumber }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex v-if="ClassInfo">
        <div v-html="ClassInfo.description"></div>
        <!-- <div>{{ ClassInfo.description }}</div> -->


      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import applicationService from "@/modules/Application/service.js";
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// require('quill/dist/quill.core.css');
// require('quill/dist/quill.snow.css');
// require('quill/dist/quill.bubble.css');

export default {
  name: 'collectDonationByCampaign',
  data() {
    return {
      ClassInfo: null,
      Business: null
    }
  },
  created() {
    this.loadDepartment()
  },
  methods: {
    loadDepartment() {
      let code = this.$route.params.code
      let id = this.$route.params.id
      console.log('getting code', code, id)
      applicationService
        .getPublicDepartment({ code: code, id: id })
        .then((response) => {
          console.log("response class", response);
          // if (!response.data) {
          //   this.$router.push({ name: "pagenotfound" });
          // }
          this.ClassInfo = response.data.classInfo
          this.Business = response.data.Business
        })
        .catch((error) => {
          console.log("response class  ", error);
          this.$router.push({ name: "pagenotfound" });
        });
    }
  }
}
</script>
<style>
.ql-align-center {
  text-align: center;
}

.ql-size-large {
  font-size: 1.5em;
}

.ql-size-huge {
  font-size: 2.5em;
}

.ql-align-right {
  text-align: right;
}

.ql-size-small {
  font-size: small;
}

blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}

pre.ql-syntax {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
}

.v-application--wrap {
  background: cornsilk;
  line-height: 1.42;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.v-application p {
  margin-bottom: 0px;
}

.v-application ul {
    padding-left: 2.5em;
}
.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}

.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}

.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}

.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}



.ql-video {
  display: block;
  width: 100%;
  height: 400px;
}
</style>